import type {
  GoodsPiece,
  MeasureValue,
  MeasurementSize,
} from 'shared/src/api/goodsService';

type MeasureValuesResult = {
  measureValues: MeasureValue[];
  dataType: 'AI_IMAGE' | 'AI_TABLE' | 'SELLER_TABLE';
  goodsExtractedMeasureImage?: string;
  sizes: MeasurementSize[];
};

export const useGetMeasureValues = () => {
  const getMeasureValues = (piece: GoodsPiece): MeasureValuesResult => {
    const { measurement, goods_extracted_measure_image } = piece;
    const { sizes, extracted_sizes } = measurement;

    // 셀러가 입력한 측정값이 있을 때는 해당값 보여주기
    if (sizes.length > 0) {
      return {
        measureValues: sizes[0].measure_values,
        dataType: 'SELLER_TABLE',
        sizes,
      };
    }

    if (goods_extracted_measure_image != null) {
      return {
        measureValues: [],
        dataType: 'AI_IMAGE',
        goodsExtractedMeasureImage:
          goods_extracted_measure_image.size_image_url,
        sizes: extracted_sizes,
      };
    }

    return {
      measureValues:
        extracted_sizes.length > 0 ? extracted_sizes[0].measure_values : [],
      dataType: 'AI_TABLE',
      sizes: extracted_sizes,
    };
  };

  return getMeasureValues;
};
